import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import type { OnboardingIdentity } from "../types";
import {
  recordInsuranceMutation,
  upsertOnboardingIntentMutation,
} from "./queries";

/** Records the user's carrier, and their member ID when they gave one. */
export function useRecordCarrier(identity: OnboardingIdentity | undefined) {
  const [recordInsurance] = useMutation(recordInsuranceMutation);
  const [upsertSegmentation] = useMutation(upsertOnboardingIntentMutation);
  return useCallback(
    async (carrier: string, payerId: string | null, memberId?: string) => {
      // hasInsurance only after the carrier lands, or resume skips this screen.
      await recordInsurance({
        variables: { input: { carrier, payerId, memberId, ...identity } },
      });
      await upsertSegmentation({
        variables: { input: { hasInsurance: true } },
      });
    },
    [recordInsurance, upsertSegmentation, identity],
  );
}
